import React from "react";
import Modal from "@restart/ui/Modal";
import { CloseIcon, EditIcon } from "asset/icons";

const RequestShipmentModal = ({ show, onClose }) => {
    return (
        <Modal
            show={show}
            onHide={onClose}
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
        >
            <div className="bg-white rounded-2xl px-6 pb-4 pt-2 shadow-xl max-w-2xl w-full">
                {/* Header */}
                <div className="flex justify-between items-center">
                    <h3 className="text-2xl font-semibold text-main-dark">Request Shipment</h3>
                    <CloseIcon
                        onClick={onClose}
                        className="cursor-pointer text-gray-500 hover:text-gray-800 w-6 h-6"
                    />
                </div>

                {/* Description */}
                <p className="text-sm text-main-grey !mb-8">
                    Send your client a link to fill in the shipment information.
                </p>

                {/* Completion Details */}
                <p className="font-semibold text-sm text-main-dark mb-2">
                    Who is completing the shipment details?
                </p>
                <div className="bg-[#F9F9FB] p-4 rounded-lg mb-6 border border-[#EAECF0]">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="font-medium text-main-dark text-[14px]">Alex Ekwueme</p>
                            <p className="text-main-grey text-sm">
                                Alex & Sons • alex.sons@gmail.com
                            </p>
                        </div>
                        <EditIcon className="cursor-pointer text-[#6F00FF]" />
                    </div>
                </div>

                {/* Info Section */}
                <div className="bg-[#DCFDDB] p-4 rounded-lg border-2 border-[#11A811]">
                    <p className="font-medium text-main-dark text-sm flex items-center mb-2">
                        <span className="text-[#28A745] mr-2 text-[16px]">🔗</span>
                        We’ll create a link for your client to complete
                    </p>
                    <p className="text-main-grey text-sm">
                        They can fill the shipping and payment details and book based on your agreed
                        terms.
                    </p>
                </div>

                {/* Actions */}
                <div className="flex border-t pt-3 justify-end mt-8 gap-1">
                    <button
                        onClick={onClose}
                        className="py-2 px-5 hover:bg-[#F7F7F7] text-main-dark rounded-lg"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onClose}
                        className="!py-3 !px-8 bg-[#6F00FF] text-white rounded-lg"
                    >
                        Send request
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default RequestShipmentModal;
